/** Format phone numbers for display only; never use this to rewrite stored data. */
export const formatPhone = (value, fallback = 'N/A') => {
  if (value == null) return fallback;
  const raw = String(value).trim().replace(/[০-৯]/g, digit => String('০১২৩৪৫৬৭৮৯'.indexOf(digit)));
  if (!raw || !/^\+?[\d\s().-]+$/.test(raw)) return fallback;
  let digits = raw.replace(/\D/g, '');
  if (digits.length < 7 || digits.length > 17) return fallback;
  const bd = digits.match(/^(?:00880|880)0?([1-9][0-9]{7,9})$/);
  if (bd) return `+880${bd[1]}`;
  if (/^0[1-9][0-9]{7,9}$/.test(digits)) return `+880${digits.slice(1)}`;
  if (/^1[3-9][0-9]{8}$/.test(digits)) return `+880${digits}`;
  if (digits.startsWith('00')) digits = digits.slice(2);
  if (digits.length > 15) return fallback;
  return raw.startsWith('+') || /^[1-9][0-9]{9,14}$/.test(digits) ? `+${digits}` : raw;
};
